module.exports = __webpack_public_path__ + "img/selected1-min.f9241123.png";